import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import Input from "@/components/ui/Input";
import { Button } from "@/components/ui/button";

interface FavoriteListFormProps {
  onSubmit: (name: string) => void;
  initialName?: string;
  submitLabel?: string;
}

export function FavoriteListForm({
  onSubmit,
  initialName = "",
  submitLabel = "Guardar",
}: FavoriteListFormProps) {
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm<{ name: string }>({
    defaultValues: { name: initialName },
  });

  const nameValue = watch("name");

  useEffect(() => {
    reset({ name: initialName });
  }, [initialName, reset]);

  return (
    <form
      onSubmit={handleSubmit((data) => onSubmit(data.name))}
      className="flex flex-col gap-4"
    >
      <Input
        label="Nombre de la lista"
        placeholder="Ej. Compras del mes"
        error={errors.name?.message}
        {...register("name", { required: "El nombre es requerido" })}
      />
      <div className="flex justify-end">
        <Button type="submit" disabled={!nameValue || nameValue.trim() === ""}>
          {submitLabel}
        </Button>
      </div>
    </form>
  );
}
